import { createContext, FC, PropsWithChildren } from "react";
import { IShareState } from "../types/share-state";
import { useShareState } from "../hooks/useShareState";

export const shareStateContext = createContext<IShareState>({
    setAdminDocumentState: () => {},
    setShareDocumentId: () => {},
    adminDocumentState: {}
});

interface IShareStateProviderProps extends PropsWithChildren {
}

export const ShareStateProvider: FC<IShareStateProviderProps> = ({ children }) => {
    const shareState = useShareState();

    return <shareStateContext.Provider value={shareState}>
        {children}
    </shareStateContext.Provider>;
}
